import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentService } from 'src/app/services/payment.service';
import { Md5 } from 'md5-typescript';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from 'src/app/auth/auth.service';
import * as moment from "moment";
@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent implements OnInit, OnChanges {
  @Input() hidePackages: boolean = false;
  @Input() amountOverride: number;
  @Input() hideSubmit = false;
  businessId = '';
  paymentForm: FormGroup;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/string'
    })
  };
  @ViewChild('submitFormForPayment') submitFormForPayment: ElementRef;
  @ViewChild('submitFormForSinglePayment') submitFormForSinglePayment: ElementRef;
  orderForm: FormGroup;
  payfastURLSandbox = 'https://sandbox.payfast.co.za​/eng/process';
  payfastURL = 'https://www.payfast.co.za/eng/process';

  packages = [
{
    durationInMonths: 12,
    priceInRand: 399.00,
    title: '12 Months',
    description: '',
    paymentInterval: 'annually',
    frequency: '6'}];
  // {
  //   durationInMonths: 6,
  //   priceInRand: 199.00,
  //   title: '6 Months',
  //   description: '',
  //   paymentInterval: 'monthly',
  //   frequency: '3'
  // },{
  //   durationInMonths: 1,
  //   priceInRand: 2999,
  //   title: 'Pay for 24 months and save',
  //   description: '',
  //   paymentInterval: 'once off',
  //   frequency: ''
  // }];
  // sandbox
  // merchant_id: '10034791',
  // merchant_key: 'n3ocmcgzphz3j',

  // live
  // merchant_id: '25041268',
  // merchant_key: 'h0xcvjn9uig1q',

  payfastObject: any = {
  merchant_id: '25041268',
  merchant_key: 'h0xcvjn9uig1q',
    return_url: 'https://www.advibe.co.za/user/paymentSuccess',
    cancel_url: 'https://www.advibe.co.za/user/paymentCancelled',
    notify_url: 'https://www.advibe.co.za/user/dashboard',
    subscription_type:1,
    name_first: '',
    name_last: '',
    email_address: '',
    cell_number: '',
    m_payment_id: '',
    amount: '',
    billing_date: '',
    billing_expiry_date: '',
    item_name: 'Advibe',
    item_description: 'A product',
    custom_int1: '2',
    custom_str1: 'Extra order information',
    email_confirmation: '1',
    confirmation_address: '',
    frequency: '3'
  };
  payfastSubmissionString = '';
  payfastSignature = '';
  wizardStep = 1;
  faCheckCircle = faCheckCircle;
  user;
  constructor(private http: HttpClient, private fb: FormBuilder, private paymentService: PaymentService, private datePipe: DatePipe, private authService: AuthService) { }

  ngOnInit(): void {
    this.paymentForm = this.fb.group({
      amount: ['', Validators.required],
      item_name: ['', Validators.required]
    })

    this.orderForm = this.fb.group({
      name: [this.user ? this.user.get('Name') : '', Validators.required],
      surname: [this.user ? this.user.get('Surname') : ''],
      billingDate: [{ value: this.datePipe.transform(new Date, 'yyyy-MM-dd'), disabled: true }],
      email: [this.user ? this.user.get('email') : '', Validators.email],
      contactNumber: [this.user ? this.user.get('Mobile') : '', Validators.required],
      cycles: ['12', Validators.required],
      address: [this.user ? this.user.get('Address') : '', Validators.required],
      package: [this.amountOverride ? this.amountOverride : (this.user && this.user.get('email') === 'info@advibe.co.za' ? '10' : '399'), Validators.required],
      dateTime: [''],
      frequency: ['6'] // 6 is used in default package
    });

    this.authService.$User.subscribe((res) => {
      if (res) {
        this.user = res;
        this.populateFromUser();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['amountOverride'] && this.orderForm) {
      this.orderForm.controls['package'].setValue(this.amountOverride);
    }
  }

  nextStep(): void {
    this.wizardStep += 1;
    window.scroll(0, 0);
  }

  previousStep(): void {
    this.wizardStep -= 1;
    window.scroll(0, 0);
  }
  makePayment(payment: any): Promise<any> {
    return this.paymentService.makePayment(payment);
  }

  isOrderValid(): boolean {
    if (this.orderForm.invalid) {
      this.orderForm.markAllAsTouched();
      return false;
    }
    return true;
  }

  private populateFromUser(): void {
    if (!this.orderForm || !this.user) return;
    const value = this.orderForm.getRawValue();
    this.orderForm.patchValue({
      name: value.name || this.user.get('Name') || '',
      surname: value.surname || this.user.get('Surname') || '',
      email: value.email || this.user.get('email') || '',
      contactNumber: value.contactNumber || this.user.get('Mobile') || '',
      address: value.address || this.user.get('Address') || ''
    });
  }

  populateFromBusiness(business: any): void {
    if (!this.orderForm || !business) return;
    const value = this.orderForm.getRawValue();
    this.orderForm.patchValue({
      name: value.name || (this.user && this.user.get('Name')) || '',
      surname: value.surname || (this.user && this.user.get('Surname')) || '',
      email: value.email || business.Email || (this.user && this.user.get('email')) || '',
      contactNumber: value.contactNumber || business.Mobile || (this.user && this.user.get('Mobile')) || '',
      address: value.address || business.Address || (this.user && this.user.get('Address')) || ''
    });
  }

  async placeOrder(businessId?: string) {
    if (!this.isOrderValid()) return;
    if (!businessId) {
      throw new Error('A business is required to start payment.');
    }

    this.businessId = businessId;
    const order = this.orderForm.getRawValue();
    const billingDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    const expiryDate = this.datePipe.transform(
      moment().add(order.cycles, 'months').toDate(),
      'yyyy-MM-dd'
    );
    const returnUrl = `https://www.advibe.co.za/user/paymentSuccess?businessId=${encodeURIComponent(this.businessId)}`;
    const cancelUrl = `https://www.advibe.co.za/user/paymentCancelled?businessId=${encodeURIComponent(this.businessId)}`;

    this.payfastObject = {
      ...this.payfastObject,
      return_url: returnUrl,
      cancel_url: cancelUrl,
      name_first: order.name,
      name_last: order.surname,
      email_address: order.email,
      cell_number: order.contactNumber,
      m_payment_id: this.businessId,
      amount: order.package,
      billing_date: billingDate,
      billing_expiry_date: expiryDate,
      recurring_amount: order.package,
      frequency: order.frequency,
      cycles: order.cycles
    };
    this.payfastSignature = await this.generateSignature();
    await this.makePayment({
      ...order,
      businessId: this.businessId,
      billing_date: billingDate,
      billing_expiry_date: expiryDate
    });
    if(this.payfastObject.frequency !== ''){
    this.submitFormForPayment.nativeElement.click();
    }else{
    this.submitFormForSinglePayment.nativeElement.click();
    }
    this.paymentService.subscriptionDetails.next(this.orderForm.value);
  }

  generateSignature(): string {
    const fields = [
      'merchant_id', 'merchant_key', 'return_url', 'cancel_url', 'notify_url',
      'name_first', 'name_last', 'email_address', 'cell_number', 'm_payment_id',
      'amount', 'item_name', 'item_description', 'custom_int1', 'custom_str1',
      'subscription_type', 'billing_date', 'recurring_amount', 'frequency', 'cycles'
    ];
    const parts = fields
      .filter(field => this.payfastObject[field] !== undefined && this.payfastObject[field] !== '')
      .map(field => `${field}=${this.encodePayFastValue(this.payfastObject[field])}`);
    this.payfastSubmissionString = parts.join('&');
    return Md5.init(`${this.payfastSubmissionString}&passphrase=${this.encodePayFastValue('aDV1b3PayMent')}`);
  }

  private encodePayFastValue(value: any): string {
    return encodeURIComponent(String(value).trim()).replace(/%20/g, '+');
  }

  selectSubscriptionPackage(subscriptionOption: any): void {
    this.orderForm.controls.cycles.setValue(subscriptionOption.durationInMonths);
      this.orderForm.controls.package.setValue(subscriptionOption.priceInRand);
      this.orderForm.controls.frequency.setValue(subscriptionOption.frequency);
  }

  async generatePaymentIdentifier(pfParamString){

    const reqHeaders = new HttpHeaders({

    })
    return await this.http.post(
      this.payfastURLSandbox,
      pfParamString, {headers: reqHeaders, responseType: 'json'}).toPromise(); 
  };

}
